<template>
<div style='position: relative;'>
  <div class='fl aic session-user-container' @click="isOpen = !isOpen">
    <div class='name-container mr-4'>
      <h6>{{ tradeName }}</h6>
      <p>{{ userFullName }}</p>
    </div>

    <div class='user-icon-container'>
      <user-icon class='user-icon' />
    </div>
  </div>

  <div class='select-employer-dropdown' v-if="isOpen">
    <div class='employer-select-item'>
      <v-icon size='20'>input</v-icon>
      <p @click="logout()">Uitloggen</p>
    </div>
    <div class='employer-select-item' v-if="isShowingEmployerSelect">
      <v-icon size='21'>search</v-icon>
      <p @click="handleOpenEmployeeSwitch()">Werkgever Selecteren</p>
    </div>
<!--
    <div class='employer-select-item' v-for="e in filteredEmployers" :key="e.id + '-select-employer-item'" @click="() => handleSelectEmployer(e)">
      <v-icon size='20'>domain</v-icon>
      <p>{{ e.tradeName }}</p>
    </div> -->
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/shared/constants/modal';

import EmployeesViews from '@/views/constants/employees';
import Employers from '@/resources/constants/employers';
import UserIcon from '@aevitae/aevitaeui/0_atoms/icons/UserIcon.vue';

export default {
  name: 'SessionUser',
  components: {
    UserIcon
  },
  data () {
    return {
      isOpen: false
    };
  },
  mounted () {
    this.$store.dispatch(Employers.Actions.LoadAll.START);
  },
  computed: {
    ...mapGetters({
      employers: 'employers',
      selectedEmployer: 'selectedEmployer',
      employersIsLoading: 'employersIsLoading'
    }),
    filteredEmployers () {
      let result = [];
      this.employers.forEach(e => {
        if (e.customerNumber !== this.selectedEmployer.customerNumber) {
          result.push(e);
        }
      });

      return result;
    },

    user () {
      return this.$AuthService.getUser();
    },
    tradeName () {
      if (this.employersIsLoading) {
        return 'Werkgevers Laden..';
      } else if (this.selectedEmployer != null) {
        return this.selectedEmployer.tradeName;
      } else {
        return '';
      }
    },
    firstName () {
      return this.user.idToken.given_name;
    },
    lastName () {
      return this.user.idToken.family_name;
    },
    userFullName () {
      return `${this.firstName} ${this.lastName}`;
    },
    isShowingEmployerSelect () {
      return this.employers.length > 1;
    }
  },
  methods: {
    handleOpen () {
      this.isOpen = !this.isOpen;
    },
    handleSelectEmployer (employer) {
      this.$store.dispatch(Employers.Actions.SELECT, employer);
      this.isOpen = false;
    },
    handleOpenEmployeeSwitch () {
      this.$store.dispatch(EmployeesViews.Actions.SwitchModal.OPEN);
      this.isOpen = false;
    },
    logout () {
      this.$store.dispatch(Modal.Actions.OPEN, {
        component: 'LogoutConfirmation'
      });
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

.user-icon-container {
  position: relative;
  padding: 10px;
  border-radius: $border-radius;
  background-color: $secondary;
  width: 53.5px;
  height: 50px;
  top: -1px;

  .user-icon {
    position: relative;
    left: 7px;
    top: 5px;
    width: 20px;
    fill: white;
  }
}

.session-user-container {
  cursor: pointer;

  .name-container {
    text-align: right;

    h6 {
      color: white;
      font-size: 1.1em;
    }

    p {
      color: $secondary-lighten-4;
      color: #9FE9FC;
      font-size: 1.1em;
      position: relative;
      top: -1px;
    }
  }
}

.select-employer-dropdown {
  min-width: 220px;
  border-radius: $border-radius;
  background-color: white;
  position: absolute;
  top: 73px;
  right: 0px;
  width: 100%;
  z-index: 999;
  overflow: hidden;

  box-shadow: 0 4px 10px rgba(0,0,0,0.15), 0 1px 6px rgba(0,0,0,0.23);
}

.employer-select-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 13px;

  &:not(:last-child) {
    border-bottom: 1px solid $gray-lighten-2;
  }

  &:hover {
    background-color: $secondary-lighten-3;
    cursor: pointer;
    p {
      color: $secondary;
    }

    .theme--light.v-icon {
      color: $secondary;
    }
  }

  .theme--light.v-icon {
    color: $primary-lighten-1;
    margin-right: 15px;
    margin-left: 4px;
  }
}

.portrait {
  margin-right: 12px;
  width: 23px;
  height: 23px;

  overflow: hidden;
  position: relative;

  box-sizing: context-box;
  overflow: visible;

  img {
    border-radius: 50%;
    margin: 0 auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    left: -4%;
    position: relative;
    top: -3%;
  }
}

</style>
